import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import ReportItem from "./ReportItem";
import { Loading } from "app/components/Wrappers";
import HistoryModal from "./Modals/HistoryModal";
import { RoleType, UserContext } from "app/contexts/UserContext";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import Tabs from "app/components/Tabs";

const ReportsPage = () => {
  const { t } = useTranslation();
  const [coachReports, setCoachReports] = useState([]);
  const [facilityReports, setFacilityReports] = useState([]);
  const [currentReport, setCurrentReport] = useState(null);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const user = useContext(UserContext);

  useEffect(() => {
    setLoading(true);

    schedulingFetchGet("reports", {})
      .then((response) => {
        if (response.coachReports) {
          setCoachReports(response.coachReports);
        }

        if (response.facilityReports) {
          setFacilityReports(response.facilityReports);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("fetchErr", err);
      });
  }, []);

  if (loading) {
    return <Loading loadType="spinner" />;
  }

  const onClose = () => {
    setOpenHistoryModal(false);
  };

  const renderReports = () => {
    if (user.role === RoleType.COACH && user.isAdmin) {
      return (
        <>
          {selectedTab === 0 &&
            (coachReports?.length > 0 ? (
              coachReports.map((report) => {
                return (
                  <ReportItem
                    key={report.id}
                    report={report}
                    setCurrentReport={setCurrentReport}
                    setOpenHistoryModal={setOpenHistoryModal}
                  />
                );
              })
            ) : (
              <p className={styles.no_reports_found}>{t("No Reports Found")}</p>
            ))}
          {selectedTab === 1 &&
            (facilityReports?.length > 0 ? (
              facilityReports?.map((report) => {
                return (
                  <ReportItem
                    key={report.id}
                    report={report}
                    setCurrentReport={setCurrentReport}
                    setOpenHistoryModal={setOpenHistoryModal}
                  />
                );
              })
            ) : (
              <p className={styles.no_reports_found}>{t("No Reports Found")}</p>
            ))}
        </>
      );
    }

    return (
      <>
        {coachReports?.map((report) => (
          <ReportItem
            key={report.id}
            report={report}
            setCurrentReport={setCurrentReport}
            setOpenHistoryModal={setOpenHistoryModal}
          />
        ))}
        {facilityReports?.map((report) => (
          <ReportItem
            key={report.id}
            report={report}
            setCurrentReport={setCurrentReport}
            setOpenHistoryModal={setOpenHistoryModal}
          />
        ))}
      </>
    );
  };

  const tabs = [
    {
      label: t('My Reports'),
      onClickHandler: () => setSelectedTab(0),
      isActive: selectedTab === 0
    },
    {
      label: t('Facility Reports'),
      onClickHandler: () => setSelectedTab(1),
      isActive: selectedTab === 1
    }
  ];

  return (
    <div>
      <div className={styles.title}>
        <h1>{t("Reports")}</h1>
        {user.role === RoleType.COACH && user.isAdmin && (
          <Tabs tabs={tabs} />
        )}
      </div>
      <div className={`${styles.container} calendar-page-container non-scrollable`}>
        <div className={styles.header_container}>
          <span className={styles.name_width}>{t("Report")}</span>
          <span className={styles.category_width}>{t("Category")}</span>
          <span className={styles.downloaded_width}>
            {t("Last Downloaded On")}
          </span>
        </div>
        {renderReports()}
      </div>
      <HistoryModal
        onClose={onClose}
        report={currentReport}
        isOpen={openHistoryModal}
      />
    </div>
  );
};

export default ReportsPage;
